export default __webpack_public_path__ + "static/media/zucchero1.d157e550.webp";